import { getAllowedValue, getResolvedCapability } from "./capabilityLookup";
import {} from "@next-platform/packages-ts-types/application/types/capabilities";
export function areAllowed(keys) {
    return keys.map((key) => getAllowedValue(key));
}
export function get(key) {
    return getResolvedCapability(key);
}
export function getMultiple(keys) {
    return Object.fromEntries(keys.map((key) => [key, getResolvedCapability(key)]));
}
export function isAllowed(key) {
    return getAllowedValue(key);
}
export const applicationCapabilities = {
    areAllowed,
    get,
    getMultiple,
    isAllowed,
};
